import { useState, useEffect } from 'react';
import { API, Endpoints, Project } from '@brg/api';
import { getLongreadId } from '../../../pages/project/sections/ps-longread';
import { useTranslation } from 'react-i18next';

export const useGetLongreadBlocks = (project?: Project, customLGId?: string) => {
  const [blocks, setBlocks] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!project) {
      setBlocks([]);
      return;
    }

    const fetchBlocks = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const longreadId = customLGId || getLongreadId(project, i18n.language);

        if (!longreadId) {
          setBlocks([]);
          setIsLoading(false);
          return;
        }

        const response = await API.request()
          .endpoint(Endpoints.longread)
          .url('api/post/GetMany')
          .addQuery('idLongread', longreadId)
          .get()
          .send();

        const posts = await response.json();
        setBlocks(Array.isArray(posts) ? posts : []);
      } catch (err) {
        console.error('Error fetching longread blocks:', err);
        setError(err);
        setBlocks([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBlocks();
  }, [project, customLGId, i18n.language]);

  return { blocks, isLoading, error };
};
import { useState, useEffect } from 'react';
import { API, Endpoints, Project } from '@brg/api';
import { getLongreadId } from '../../../pages/project/sections/ps-longread';
import { useTranslation } from 'react-i18next';

export const useGetLongreadBlocks = (project?: Project, customLGId?: string) => {
  const [blocks, setBlocks] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!project) {
      setBlocks([]);
      return;
    }

    const fetchBlocks = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const longreadId = customLGId || getLongreadId(project, i18n.language);

        if (!longreadId) {
          setBlocks([]);
          setIsLoading(false);
          return;
        }

        const response = await API.request()
          .endpoint(Endpoints.longread)
          .url('api/post/GetMany')
          .addQuery('idLongread', longreadId)
          .get()
          .send();

        const posts = await response.json();
        setBlocks(Array.isArray(posts) ? posts : []);
      } catch (err) {
        console.error('Error fetching longread blocks:', err);
        setError(err);
        setBlocks([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBlocks();
  }, [project, customLGId, i18n.language]);

  return { blocks, isLoading, error };
};
